import { StateModel } from '../models';

export class StateModelFactory {
  public create(state: StateModel): StateModel {
    state = Object.assign(new StateModel(), state);
    return state;
  }
}
